var $ = require('jquery');

$('body').on('click', '.tool_tip_holder .show_tool_tip .icon', function() {
	$(this).parents('.tool_tip_holder').find('.tool_tip').slideToggle('fast');
});



/** WEBPACK FOOTER **
 ** ./utility/tooltip.js
 **/